// extracted by mini-css-extract-plugin
export default {"root":"_35z7Z","small":"_1NOIE","normal":"_PvXa"};